import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 46 32" {...props}>
    <path
      stroke={props.color || "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.637 1.893h43.568M1.637 16.162h43.568M1.637 30.432h43.568"
    />
  </svg>
);
export { SvgComponent as BurgerMenuBars };
